import { Component } from '@angular/core';

@Component({
  selector: 'icon-delete',
  templateUrl: './icon-delete.component.html',
  styleUrls: ['./icon-delete.component.sass']
})
export class IconDeleteComponent {}
